<template>
<div id="ASpotContainer" class="d-md-flex align-items-flex-start">
    <!-- Use the model to populate template, example. -->
    <div>
        <h1>{{ model.Title }}</h1>

        <img @click="openYouTubeModal()" :src="model.ASpotImageUrl" alt="" class="d-md-none" :class="{ 'cursor-pointer': model.VideoUrl, hide: !model.ASpotImageUrl }" />

        <p>
            {{ model.Summary }}
        </p>

        <router-link :to="{ name: model.ArticleName }">
            <div @click="AddGAEvent()" class="pill-btn red filled full-width-mobile">Learn more</div>
        </router-link>
    </div>
    <figure>
        <img @click="openYouTubeModal()" :src="model.ASpotImageUrl" class="d-none d-md-block" :class="{ 'cursor-pointer': model.VideoUrl }" />
    </figure>
</div>
</template>

<script>
import {
    EventBus
} from "@/event-bus.js";
import {
    globalEventConsts
} from "@/constants.js";

export default {
    name: "ASpotFullWidth",
    props: {
        model: {
            type: Object,
            default () {
                return {}
            }
        },
    },
    data() {
        return {
            isModalOpen: false,
        };
    },
    methods: {
        openYouTubeModal() {
            if (this.model.VideoUrl.trim()) {
                EventBus.$emit(globalEventConsts.SHOW_YOUTUBE_MODAL, this.model.VideoUrl);
            }
        },
        AddGAEvent(){
            this.pushEventToGoogleDataLayer("agent_portal", "learn_more_clicked", this.model.Title, 0);
        }
    },
};
</script>

<style lang="scss" scoped>
#ASpotContainer {
    .pill-btn{
        padding-top: $spacer-three;
    }
    .cursor-pointer {
        &:hover {
            cursor: pointer;
        }
    }
    a{
        &:hover {
                text-decoration: none;
            }
        .pill-btn {
            margin-top: $spacer-three;
        }
    }

    @include tablet {
        padding: 40px $page-padding $spacer-seven;

        &>* {
            width: 50%;

            p {
                padding-right: $spacer-three;
            }

            h4 {
                padding-top: $spacer-three;
            }
        }

        img {
            max-width: 100%;
            padding-left: $spacer-three;
        }
    }

    @include wide-mobile {
        padding: $spacer-six $page-padding 40px;

        h1 {
            padding-bottom: $spacer-four;
        }

        img {
            width: calc(100% + 30px);
            margin-left: -$spacer-four;
            padding: 0 0 $spacer-one 0;
        }

        p {
            padding-top: $spacer-three;
        }

        h4 {
            padding-top: $spacer-one;
        }
    }
}
</style>
